import z from 'zod';

export const DeleteSnapLikedServiceRequestSchema = z
  .object({
    snapId: z.string(),
  })
  .describe('DeleteSnapLikedServiceRequestSchema');

export type DeleteSnapLikedServiceRequest = z.infer<typeof DeleteSnapLikedServiceRequestSchema>;

export const DeleteSnapLikedServiceResponseSchema = z
  .object({
    success: z.boolean(),
  })
  .describe('DeleteSnapLikedServiceResponseSchema');

export type DeleteSnapLikedServiceResponse = z.infer<typeof DeleteSnapLikedServiceResponseSchema>;
